'use strict';/* global define */define('modules/time/filters/lls-period-dates/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     filter.$inject = ["$filter"];
function filter($filter){// jshint validthis:true
// jshint latedef:false
var llsDate=$filter('llsDate');/**
     * Date filter
     *
     * @param  {Date} date     - Date object
     * @param  {String} format - Provided format
     *
     * @return {String}        - Formatted date string
     *
     * @tested
     */return function(period){return llsDate(period.start)+' - '+llsDate(period.end);};}module.exports=filter;});
